import React, { useState } from 'react'
import PakageCommunityHistory from '../components/PakageCommunityHistory/PakageCommunityHistory'

const PakageCommunityHistoryPage = () => {
  return (
    <>
      <PakageCommunityHistory />
    </>
  )
}

export default PakageCommunityHistoryPage
